import axios from 'axios/index'

const namespaced = true

const state = {
  nsiCountries: null,
  nsiAuthorities: null,
  nsiPorts: null,
  nsiDeliveryCodes: null,
  nsiProcedures: null,
  nsiMeasurement: null,
  nsiPacking: null,
  nsiDocuments: null,
  nsiHazardClasses: null,
  commissionShipmentDoc: null,
  inventoryDoc: null,
  freeBinaryDoc: null,
  packageDocumentsList: null,
  packagePid: null,
  packageChainid: null,
  packageStatus: null
}

const actions = {
  loadDt ({ commit }, data) {
    let formData = new FormData();
    for( var i = 0; i < data.length; i++ ){
      let file = data[i].file;
      formData.append('files', file);
    }
    return new Promise((resolve, reject) => {
      axios.post('/api/private/v5.0/commission-shipment/from-dt-xml/',
          formData
      )
        .then(response => {
          commit('setPackagePid', response.data)
          resolve({ pid: response.data.pid })
        })
        .catch(error => {
          reject(error)
        })
    })
   },
  loadNsiCountries ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `${process.env.VUE_APP_NSI_HOST}nsi/countries`,
        params: data
      })
        .then(response => {
          commit('setNsiCountries', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadNsiAuthorities ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `${process.env.VUE_APP_NSI_HOST}nsi/customs/authorities`,
        params: data
      })
        .then(response => {
          commit('setNsiAuthorities', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadNsiPorts ({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `${process.env.VUE_APP_NSI_HOST}nsi/ports`,
        params: data
      })
        .then(response => {
          commit('setNsiPorts', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadNsiDeliveryCodes ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `${process.env.VUE_APP_NSI_HOST}nsi/customs/conditions`
      })
        .then(response => {
          commit('setNsiDeliveryCodes', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadNsiProcedures ({ commit }, data) {
    let settings = {
      method: 'GET',
      url: `${process.env.VUE_APP_NSI_HOST}nsi/customs/procedures`
    }
    if (data && data.p && (data.p.length > 0)) {
      settings = Object.assign(settings, { params: data })
    }
    return new Promise((resolve, reject) => {
      axios(settings)
        .then(response => {
          commit('setNsiProcedures', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadNsiMeasurement ({ commit }, data) {
    let settings = {
      method: 'GET',
      url: `${process.env.VUE_APP_NSI_HOST}nsi/measurement`
    }
    if (data && data.p && (data.p.length > 0)) {
      settings = Object.assign(settings, { params: data })
    }
    return new Promise((resolve, reject) => {
      axios(settings)
        .then(response => {
          commit('setNsiMeasurement', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadNsiPacking ({ commit }, data) {
    let settings = {
      method: 'GET',
      url: `${process.env.VUE_APP_NSI_HOST}nsi/packing`
    }
    if (data && data.p && (data.p.length > 0)) {
      settings = Object.assign(settings, { params: { p: data.p, type: '' } })
    }
    return new Promise((resolve, reject) => {
      axios(settings)
        .then(response => {
          commit('setNsiPacking', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadNsiPackingContainers ({ commit }, data) {
    let settings = {
      method: 'GET',
      url: `${process.env.VUE_APP_NSI_HOST}nsi/packing`
    }
    if (data && data.p && (data.p.length > 0)) {
      settings = Object.assign(settings, { params: { p: 'контейнер', type: data.p } })
    } else {
      settings = Object.assign(settings, { params: { p: 'контейнер', type: '' } })
    }
    return new Promise((resolve, reject) => {
      axios(settings)
        .then(response => {
          commit('setNsiPacking', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadNsiDocuments ({ commit }, data) {
    let settings = {
      method: 'GET',
      url: `${process.env.VUE_APP_NSI_HOST}nsi/customs/documents`
    }
    if (data && data.p && (data.p.length > 0)) {
      settings = Object.assign(settings, { params: data })
    }
    return new Promise((resolve, reject) => {
      axios(settings)
        .then(response => {
          commit('setNsiDocuments', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadNsiHazardClasses ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `${process.env.VUE_APP_NSI_HOST}nsi/hazard-classes`,
        params: {
          p: data.p
        }
      })
        .then(response => {
          commit('setNsiHazardClasses', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createCommissionShipmentDoc ({ commit }, data) {
    const payload = {
      pid: data.pid,
      chainid: data.chainid,
      data: data.data
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/api/private/v5.0/commission-shipment/',
        data: payload
      })
        .then(response => {
          commit('setPackagePid', response.data)
          resolve({ did: response.data.document.did })
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editCommissionShipmentDoc (_, data) {
    const payload = {
      pid: data.pid,
      chainid: data.chainid,
      data: data.data
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url: '/api/private/v5.0/commission-shipment/',
        data: payload
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getCommissionShipmentDoc ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/commission-shipment/${data.pid}/`
      })
        .then(response => {
          commit('setCommissionShipmentDoc', { data: response.data, new: data.new })
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createFreeBinaryDoc ({ commit }, data) {
    const payload = {
      pid: data.pid,
      did: data.did,
      chainid: data.chainid,
      data: data.data
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/api/private/v5.0/free-binary-doc/',
        data: payload
      })
        .then(response => {
          commit('setPackagePid', response.data)
          resolve({ did: response.data.document.did })
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editFreeBinaryDoc (_, data) {
    const payload = {
      pid: data.pid,
      did: data.did,
      chainid: data.chainid,
      data: data.data
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url: '/api/private/v5.0/free-binary-doc/',
        data: payload
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteFreeBinaryDoc (_, data) {
    const payload = {
      pid: data.pid,
      did: data.did
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'DELETE',
        url: '/api/private/v5.0/free-binary-doc/',
        params: payload
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  downloadFreeBinaryDocData ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/api/private/v5.0/free-binary-doc/',
        params: {
          pid: data.pid,
          did: data.did
        }
      })
        .then(response => {
          commit('setFreeBinaryDocData', { data: response.data })
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getFreeBinaryDoc ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/api/private/v5.0/free-binary-doc/',
        params: {
          pid: data.pid,
          did: data.did
        }
      })
        .then(response => {
          commit('setFreeBinaryDoc', { data: response.data, new: data.new })
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createInventoryDoc ({ commit }, data) {
    const payload = {
      pid: data.pid,
      data: data.data
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/api/private/v5.0/commission-shipment-inventory/',
        data: payload
      })
        .then(response => {
          commit('setPackagePid', response.data)
          resolve({ did: response.data.document.did })
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editInventoryDoc (_, data) {
    const payload = {
      pid: data.pid,
      data: data.data
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url: '/api/private/v5.0/commission-shipment-inventory/',
        data: payload
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getInventoryDoc ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/commission-shipment-inventory/${data.pid}/`
      })
        .then(response => {
          commit('setInventoryDoc', { data: response.data, new: data.new })
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteInventoryDoc (_, data) {
    const payload = {
      pid: data.pid,
      did: data.did
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'DELETE',
        url: '/api/private/v5.0/commission-shipment-inventory/',
        params: payload
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPackageDocumentsList ({ commit }, data) {
    commit('setPackageDocumentsList', null)
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/packages/${data}/`
      })
        .then(response => {
          commit('setPackageDocumentsList', response.data)
          commit('setPackagePid', response.data)
          commit('setPackageChainid', response.data)
          commit('setPackageStatus', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  sendPackageFts (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `/api/private/v5.0/packages/send/${data}/`
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
const mutations = {
  setNsiCountries (state, value) {
    state.nsiCountries = value
  },
  setNsiAuthorities (state, value) {
    state.nsiAuthorities = value
  },
  setNsiPorts (state, value) {
    state.nsiPorts = value
  },
  setNsiDeliveryCodes (state, value) {
    state.nsiDeliveryCodes = value
  },
  setNsiProcedures (state, value) {
    state.nsiProcedures = value
  },
  setNsiMeasurement (state, value) {
    state.nsiMeasurement = value
  },
  setNsiPacking (state, value) {
    state.nsiPacking = value
  },
  setNsiDocuments (state, value) {
    state.nsiDocuments = value
  },
  setNsiHazardClasses (state, value) {
    state.nsiHazardClasses = value
  },
  setCommissionShipmentDoc (state, value) {
    const isNewPackageInChain = [94, 273, 266, 4, 6].find((item) => {
      return item === parseInt(state.packageStatus)
    })
    if (value) {
      if ((!!isNewPackageInChain === true) || value.new) {
        if (value.data) value.data.did = null
      }
      state.commissionShipmentDoc = value.data
    }
  },
  setInventoryDoc (state, value) {
    const isNewPackageInChain = [94, 273, 266, 4, 6].find((item) => {
      return item === parseInt(state.packageStatus)
    })
    if (value) {
      if ((!!isNewPackageInChain === true) || value.new) {
        if (value) value.data.did = null
      }
      state.inventoryDoc = value.data
    }
  },
  setPackageDocumentsList (state, value) {
    state.packageDocumentsList = value
  },
  setFreeBinaryDoc (state, value) {
    const isNewPackageInChain = [94, 273, 266, 4, 6].find((item) => {
      return item === parseInt(state.packageStatus)
    })
    if (value) {
      const INVENTDOCUMENT_ITEM = state.inventoryDoc.data.InventDocument.INVENTDOCUMENT_ITEM.find((item) => {
        return parseInt(item.did) === parseInt(value.data.did)
      })
      INVENTDOCUMENT_ITEM.freebinarydoc = value.data.data
      if ((!!isNewPackageInChain === true) || value.new) {
        INVENTDOCUMENT_ITEM.did = null
      }
    }
  },
  setFreeBinaryDocData (state, value) {
    state.freeBinaryDoc = value.data
  },
  setPackagePid (state, value) {
    state.packagePid = value.pid
  },
  setPackageChainid (state, value) {
    state.packageChainid = value.chainid
  },
  setPackageStatus (state, value) {
    state.packageStatus = value.status
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
